/* Persistence.
 *
 * `state` is exported as a `let`. ES module live bindings mean importers see
 * reassignment done here, so setState() below is how reset/restore replace the
 * whole store without every module holding a stale reference.
 */

import { KEY, SEED } from './constants.js';
import { stage } from './stages.js';

export function blank(r,i){return{id:"s"+i,art:r[0],term:r[1],plural:r[2],trans:r[3],ex:r[4],pos:r[5],
  ease:2.5,interval:0,reps:0,lapses:0,due:0,seen:0,lp:0,suspended:false,folder:null,peak:0,leech:false,
  sk:{rec:0,gen:0,pro:0,app:0},skd:{rec:{d:null,e:0},gen:{d:null,e:0},pro:{d:null,e:0},app:{d:null,e:0}}};}
export function seedCards(){
  const cards=SEED.map(blank);
  cards.forEach(c=>c.folder="Example");
  return cards;
}
export function load(){
  try{
    const raw=localStorage.getItem(KEY)||localStorage.getItem("vokabelspiel.v2");
    if(raw){const s=JSON.parse(raw);
      if(s&&s.cards&&s.cards.length){
        s.cards.forEach(c=>{
          if(!c.sk)c.sk={rec:0,gen:0,pro:0,app:0};
          if(!c.skd)c.skd={rec:null,gen:null,pro:null,app:null};
          if(c.lp===undefined)c.lp=(c.reps&&c.interval>0)?2:0;
          if(c.suspended===undefined)c.suspended=false;
          if(c.folder===undefined)c.folder=null;
          if(c.leech===undefined)c.leech=false;
          if(c.peak===undefined)c.peak=stage(c);   /* existing words keep credit for where they already are */
        });
        if(s.sound===undefined)s.sound=true;
        if(!s.folders)s.folders=[];
        if(s.leechAt===undefined)s.leechAt=8;
        if(s.dailyCap===undefined)s.dailyCap=60;
        if(s.dayStamp===undefined){s.dayStamp=null;}
        if(!Array.isArray(s.dayWords))s.dayWords=[];
        /* Repair saves damaged by the runaway-interval bug: anything beyond a
           year was never earned, so pull it back to a sane review date. */
        s.cards.forEach(c=>{
          if(c.interval>365){c.interval=30;c.due=Date.now()+30*864e5;c.ease=Math.min(c.ease||2.5,2.5);}
          ['rec','gen','pro','app'].forEach(k=>{
            const v=c.skd&&c.skd[k];
            if(typeof v==='string')c.skd[k]={d:v,e:0};
            else if(!v||typeof v!=='object')c.skd[k]={d:null,e:0};
          });
        });
        if(!s.enrichLog)s.enrichLog=[];
        if(s.onboarded===undefined)s.onboarded=true;  /* returning users skip the intro */
        return s;}}
  }catch(e){}
  return{cards:seedCards(),streak:0,lastDay:null,reviews:0,sound:true,folders:["Example"],
    leechAt:8,dailyCap:60,dayStamp:null,dayWords:[],enrichLog:[],onboarded:false};
}
export function save(){try{localStorage.setItem(KEY,JSON.stringify(state));}catch(e){}}

export let state = load();
export function setState(next) { state = next; save(); }
